<mat-card class="daxa-card maps-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <div class="maps-card__title">
                <span class="maps-card__kicker">{{ 'pie_dashboard.map.kicker' | translate }}</span>
                <h5 class="mb-0">
                    {{ 'pie_dashboard.map.network_title' | translate }}
                </h5>
            </div>
        </mat-card-title>
        <mat-card-subtitle>
            <button mat-button class="reset-map-btn" type="button" (click)="resetMapView()">
                <i class="material-symbols-outlined">my_location</i>
                {{ "Reset_map_view" | translate }}
            </button>
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="d-flex flex-grow-1">
        <div class="map-shell">
            <div class="map-summary">
                <div>
                    <span>{{ 'Online' | translate }}</span>
                    <strong>{{ onlinePlants }}</strong>
                </div>
                <div>
                    <span>{{ 'Abnormal' | translate }}</span>
                    <strong>{{ abnormalPlants }}</strong>
                </div>
                <div>
                    <span>{{ 'Offline' | translate }}</span>
                    <strong>{{ offlinePlants }}</strong>
                </div>
                <div>
                    <span>{{ 'Production' | translate }}</span>
                    <strong>{{ totalProduction | number:'1.0-2' }} kWh</strong>
                </div>
            </div>

            <div *ngIf="isBrowser" id="map">
                <div
                    class="ctrl-hint"
                    *ngIf="showCtrlOverlay"
                >
                    {{ "CtrlHint" | translate }}
                </div>
            </div>

            <div class="map-legend">
                <span class="legend-item legend-item--online">{{ 'Online' | translate }}</span>
                <span class="legend-item legend-item--abnormal">{{ 'Abnormal' | translate }}</span>
                <span class="legend-item legend-item--offline">{{ 'Offline' | translate }}</span>
            </div>
        </div>
    </mat-card-content>
</mat-card>
